<script setup lang="ts">
import Icon from './Icon.vue';

/** 403 placeholder — either "module not entitled" or a plain permission denial. */
defineProps<{
  title: string;
  description?: string;
}>();
</script>

<template>
  <div
    class="jv-state flex flex-col items-center gap-4 rounded-jv-lg bg-jv-surface-lowest px-6 py-10 text-center"
    data-test="forbidden-state"
  >
    <span class="grid size-24 place-items-center rounded-full bg-jv-surface-low text-jv-primary">
      <Icon name="shield_lock" :size="44" />
    </span>
    <div>
      <p class="m-0 text-lg leading-[26px] font-semibold text-jv-on-surface">{{ title }}</p>
      <p v-if="description" class="m-0 mt-1 max-w-sm text-sm text-jv-on-surface-variant">{{ description }}</p>
    </div>
    <div v-if="$slots.default" class="mt-1">
      <slot />
    </div>
  </div>
</template>
